import { render, staticRenderFns } from "./detail_management.vue?vue&type=template&id=1ed7a265&scoped=true&"
import script from "./detail_management.vue?vue&type=script&lang=js&"
export * from "./detail_management.vue?vue&type=script&lang=js&"
import style0 from "./detail_management.vue?vue&type=style&index=0&id=1ed7a265&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed7a265",
  null
  
)

export default component.exports